export default {
    BASE_URL: 'https://pharmbonus.com',
    API_URL: 'https://api.pharmbonus.com'
  };